import { HistoryBatchDesktop } from 'components/HistoryBatch/HistoryBatchDesktop';
import HistoryMobile from 'components/HistoryBatch/HistoryMobile';
import React from 'react';
import { isMobile } from 'react-device-detect';

const History = () => {
  if (isMobile) return <HistoryMobile />;

  return <HistoryBatchDesktop />;
};

export default History;
